module.exports = __webpack_public_path__ + "img/typeahead-marker-icon.svg";